import * as defaultImport from "@splunk/visualizations/Ellipse";
export * from "@splunk/visualizations/Ellipse";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
